import type { CoreOfficeDataType } from '~/types/offices';
import RequestDatepickerComponent from '~/components/pages/office/RequestDatepickerComponent';
import { dateTimeOrStringToDate } from '~/components/utils/date';
import { Button } from '~/components/common/buttons/Button';
import { useOutsideClick } from '~/hooks/useOutsideClick';

type TProps = {
  office: CoreOfficeDataType;
  selectedStartDate?: Date;
  selectedEndDate?: Date;
  close: () => void;
  clear: () => void;
  apply: (start: Date, end: Date) => void;
};
const RequestDatepickerDropdown = ({ office, close, selectedStartDate, selectedEndDate, clear, apply }: TProps) => {
  const earliestStartDate = new Date(office.earliestStartDate);
  const today = new Date();

  const datepickerDropdownRef = useOutsideClick(() => {
    close();
  });

  return (
    <div
      className="datepicker-dropdown position-absolute mt-3 end-0"
      ref={datepickerDropdownRef}
    >
      <div className="fo-border-sm border-grey-200 rounded-3 bg-white">
        <div className="position-absolute end-0 top-0">
          <div className="m-3">
            <Button
              variant={'primaryGhost'}
              onClick={close}
            >
              <span className="fo-icon fo-icon-cross" />
            </Button>
          </div>
        </div>
        <RequestDatepickerComponent
          earliestStart={earliestStartDate < today ? today : earliestStartDate}
          latestEndOffice={
            office.lastAvailabilityDate === null ? undefined : dateTimeOrStringToDate(office.lastAvailabilityDate)
          }
          minDuration={office.minDuration}
          maxDuration={office.maxDuration}
          monthsShown={2}
          selectedStartDate={selectedStartDate}
          selectedEndDate={selectedEndDate}
          clear={clear}
          apply={(start, end) => {
            // console.log('start=', start, ' end=', end);
            apply(start, end);
            close();
          }}
          dismiss={close}
        />
      </div>
    </div>
  );
};

export default RequestDatepickerDropdown;
